// run swiper by using data-swiper attribute
import "./swiperHandler";
import parallax from "./parallax";
import scrollObserver from "./scrollObserver";

document.addEventListener('DOMContentLoaded', () => {
    /**
     * Parallax
     */
    const parallaxItems = document.querySelectorAll('.parallax');
    if (parallaxItems?.length) {
        parallax(parallaxItems);
    }

    /**
     * Is in viewport
     */
    const isInViewportItems = document.querySelectorAll('.is-in-viewport');
    if (isInViewportItems?.length) {
        scrollObserver({items: isInViewportItems}, callback);
    }

    /**
     * In viewport autoplay (carousel, slider)
     */
    const inViewportAutoplayItems = document.querySelectorAll('.mapo-blocks-slider, .mapo-blocks-carousel');
    if (inViewportAutoplayItems?.length) {
        function callback(entry) {
            if (!entry.target.classList.contains('in-viewport-autoplay')) {
                return;
            }

            const swiper = entry.target.querySelector('.swiper');
            const swiperInstance = swiper?.swiperInstance;
            if (!swiperInstance || !swiperInstance.autoplay) {
                return;
            }

            if (entry.isIntersecting) {
                swiperInstance.autoplay.start();
            } else {
                swiperInstance.autoplay.stop();
            }
        }

        scrollObserver({items: inViewportAutoplayItems}, callback);
    }
});